import { render, staticRenderFns } from "./order_info.vue?vue&type=template&id=d3c244a2&scoped=true"
import script from "./order_info.vue?vue&type=script&lang=js"
export * from "./order_info.vue?vue&type=script&lang=js"
import style0 from "./order_info.vue?vue&type=style&index=0&id=d3c244a2&prod&lang=scss&scoped=true"
import style1 from "./order_info.vue?vue&type=style&index=1&id=d3c244a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c244a2",
  null
  
)

export default component.exports